import cookie, { CookieSerializeOptions } from 'cookie';

export const getCookie = (name: string) => cookie.parse(document.cookie)[name];

const getCookieOptions = (
  opt: CookieSerializeOptions,
): CookieSerializeOptions => ({
  path: '/',
  secure: document.location.protocol === 'https:',
  sameSite: true,
  domain: `.${document.location.hostname}`,
  ...opt,
});

export function setCookie(name: string, value: string, duration?: number) {
  document.cookie = cookie.serialize(
    name,
    value,
    getCookieOptions(typeof duration === 'number' ? { maxAge: duration } : {}),
  );
}

export function deleteCookie(name: string) {
  document.cookie = cookie.serialize(name, '', getCookieOptions({ maxAge: 0 }));
}
